import { render, staticRenderFns } from "./allProgram.vue?vue&type=template&id=0876ab7a&scoped=true&"
import script from "./allProgram.vue?vue&type=script&lang=js&"
export * from "./allProgram.vue?vue&type=script&lang=js&"
import style0 from "./allProgram.vue?vue&type=style&index=0&id=0876ab7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876ab7a",
  null
  
)

export default component.exports